define('view/controller/booking/provider/ProviderEmptyView',['require','lib/view/LayoutView'],function (require) {

	var LayoutView = require('lib/view/LayoutView');
	
	/**
	 * Provider empty view
	 * 
	 * @class ProviderEmptyView
	 */
	return LayoutView.extend({

		template: '#provider_empty',

		serializeData: function () {
			return _.extend(LayoutView.prototype.serializeData.call(this, arguments), {
				'query': this.options.query
			});
		}
	    
	});
	
});
